import { Component, inject, Input } from '@angular/core';
import { ElementData } from '@app/core/models/courses.model';
import { ModalAssessmentExecutionService } from '@app/modules/assessments-manager/shared/modal-assessment-execution/modal-assessment-execution.service';
import { notNull } from '@app/shared/utils';
import { AppSelectors } from '@app/store';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-test-card',
  templateUrl: './test-card.component.html',
  standalone: false,
})
export class TestCardComponent {
  private readonly _store = inject(Store);
  private readonly _modalAssessmentExecutionService = inject(ModalAssessmentExecutionService);
  @Input() public element: ElementData;
  @Input() public fullWidth = false;
  @Input() public fullSize = false;
  @Input() public elementInfo;
  @Input() public preview = false;
  @Input() public dailyId?: number | string;
  @Input() public paddingBottom = false;

  constructor() {
    this._store
      .select(AppSelectors.ActiveUser)
      .pipe(notNull())
      .subscribe((user) => (this.preview = !user.aluno_id));
  }

  public onOpenQuiz(quizUuid: string, trilhaSlug: string = null, eventoId: number = null, elementoSlug: string = null) {
    this._modalAssessmentExecutionService.open({
      data: { aplicacao_uuid: quizUuid },
      extra: {
        preview: this.preview,
        trilha: {
          eventoId,
          trilhaSlug,
          elementoSlug,
          dailyId: this.dailyId,
        },
      },
    });
  }
}
